import {
    ChangeDetectionStrategy,
    Component,
    computed,
    HostBinding,
    input,
    Signal,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Label, LabelsLocation } from './floori-labels-data';
import { FlooriIconComponent } from '../floori-icon/floori-icon.component';
import { TranslationsModule } from '../../modules';

@Component({
    selector: 'floori-labels',
    standalone: true,
    imports: [CommonModule, FlooriIconComponent, TranslationsModule],
    templateUrl: './floori-labels.component.html',
    styleUrls: ['./floori-labels.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlooriLabelsComponent {
    allLabels = input<Label[]>([]);
    displayMerged = input<boolean>(false);

    validLabels = computed(() => {
        return this.allLabels().filter(label => !!label.label);
    });
    labelsTopLeft = computed(() => {
        return this.validLabels().filter(label => label.location === LabelsLocation.topLeft);
    });
    labelsTopRight = computed(() => {
        return this.validLabels().filter(label => label.location === LabelsLocation.topRight);
    });
    labelsBottomLeft = computed(() => {
        return this.validLabels().filter(label => label.location === LabelsLocation.bottomLeft);
    });
    labelsBottomRight = computed(() => {
        return this.validLabels().filter(label => label.location === LabelsLocation.bottomRight);
    });

    @HostBinding('class.floori-labels') hostClass = true;
}
